import { Box, Grid, Typography } from '@mui/material';
import { Checkbox } from '@components/checkbox';
import { FormControlLabel } from '@components/formControlLabel';
import { FormSection } from '@components/forms';
import { TFormField } from '@models/forms';
import { GetAppointedLink } from '@pages/Login/SignUpView/GetAppointedLink';

export const LegacyPartnerAffiliationSection = ({
  partnerFieldChecked,
  lockForm,
  partnerFields,
  onPartnerFieldToggle,
}: {
  partnerFieldChecked: boolean;
  lockForm: boolean;
  partnerFields: { [fieldName: string]: TFormField };
  onPartnerFieldToggle: () => void;
}) => (
  <>
    <Grid
      size={{ xs: 12 }}
      sx={{
        mt: 1,
        textAlign: 'left',
      }}
    >
      <FormControlLabel
        label={
          <Box>
            <Typography variant='caption'>
              I am affiliated with a LIO appointed brokerage or partner and have a Partner ID. ( <GetAppointedLink />)
            </Typography>
          </Box>
        }
        checked={partnerFieldChecked}
        control={
          <Checkbox
            sx={{
              marginTop: -2,
              paddingLeft: 0,
            }}
            disabled={lockForm}
            checked={partnerFieldChecked}
            onChange={onPartnerFieldToggle}
          />
        }
      />
    </Grid>

    {partnerFieldChecked && (
      <Grid size={{ xs: 12 }}>
        <FormSection fields={partnerFields} styleConfig={{ spacing: 0 }} />
      </Grid>
    )}
  </>
);
